"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BookingStatus = exports.BookingProvider = exports.BookingEventType = void 0;
var BookingStatus = /*#__PURE__*/function (BookingStatus) {
  BookingStatus["Canceled"] = "canceled";
  BookingStatus["Scheduled"] = "scheduled";
  BookingStatus["Completed"] = "completed";
  BookingStatus["Reservation"] = "reservation";
  return BookingStatus;
}({});
exports.BookingStatus = BookingStatus;
var BookingProvider = /*#__PURE__*/function (BookingProvider) {
  BookingProvider["ScheduleOnce"] = "schedule-once";
  BookingProvider["Cronofy"] = "cronofy";
  return BookingProvider;
}({});
exports.BookingProvider = BookingProvider;
var BookingEventType = /*#__PURE__*/function (BookingEventType) {
  BookingEventType["PhysicianFirstCheckin"] = "physician-first-checkin";
  BookingEventType["PhysicianCheckin"] = "physician-checkin";
  BookingEventType["TherapyCall"] = "therapy-call";
  BookingEventType["Miscellaneous"] = "miscellaneous";
  BookingEventType["Unknown"] = "unknown";
  BookingEventType["PhysicianIntroCall"] = "physician-intro-call";
  return BookingEventType;
}({});
exports.BookingEventType = BookingEventType;